/**
 * Configuración en tiempo de ejecución.
 *
 * Vite congela `import.meta.env` en el build, lo que impide reusar una imagen
 * entre ambientes. Por eso la configuración llega por `window.__APP_CONFIG__`,
 * que el entrypoint del contenedor escribe en /config.js al arrancar (spec §7).
 */

export interface AppConfig {
  COTALKER_API_URL: string
  /**
   * Base del backend propio. Resuelve las órdenes de una incidencia con una
   * credencial de servicio, porque el usuario final no ve las tareas del
   * flujo de órdenes. Ver bff/handler.mjs.
   */
  BFF_URL: string
  COTALKER_WEB_URL: string
  TASK_GROUP_INCIDENTS: string
  TASK_GROUP_WORK_ORDERS: string
  TRUSTED_ORIGINS: string[]
  USE_MOCKS: boolean
}

declare global {
  interface Window {
    __APP_CONFIG__?: Partial<AppConfig>
  }
}

const DEFAULTS: AppConfig = {
  COTALKER_API_URL: 'https://staging.cotalker.com',
  BFF_URL: '/bff',
  COTALKER_WEB_URL: 'https://web.staging.cotalker.com',
  TASK_GROUP_INCIDENTS: '61ef10a1785d17cf1745df85',
  TASK_GROUP_WORK_ORDERS: '61ef10a1785d170be845df87',
  TRUSTED_ORIGINS: [],
  USE_MOCKS: false,
}

const raw = (typeof window !== 'undefined' && window.__APP_CONFIG__) || {}

const stripSlash = (u: string) => u.replace(/\/+$/, '')

export const config: AppConfig = {
  ...DEFAULTS,
  ...raw,
  COTALKER_API_URL: stripSlash(raw.COTALKER_API_URL ?? DEFAULTS.COTALKER_API_URL),
  BFF_URL: stripSlash(raw.BFF_URL ?? DEFAULTS.BFF_URL),
  COTALKER_WEB_URL: stripSlash(raw.COTALKER_WEB_URL ?? DEFAULTS.COTALKER_WEB_URL),
  TRUSTED_ORIGINS: raw.TRUSTED_ORIGINS ?? DEFAULTS.TRUSTED_ORIGINS,
}

/** Enlace profundo a la tarea en Cotalker: sirve igual para incidencia y OT. */
export function cotalkerChannelUrl(channel: string | null | undefined): string | null {
  return channel ? `${config.COTALKER_WEB_URL}/channel/${channel}` : null
}
